import {
  Button,
  // Checkbox,
  Classes,
  Colors,
  FormGroup,
  InputGroup,
  Intent,
} from '@blueprintjs/core';
import * as React from 'react';
import styled from 'react-emotion';
import { DialogPanelContainer } from '.';
import { auth } from '../../firebase';

import { createAccountWithEmail, signInWithEmail } from '../../store/actions';
// import StaffOnboarding from './StaffOnboarding';
// import "../../styles/styles.css";
interface ISignInEmailOwnProps {
  onCloseDialog: () => void;
  onToggleDialogLock: (lock?: boolean) => void;
}

const enum SignInDialogView {
  CREATE_ACCOUNT = 'CREATE_ACCOUNT',
  FORGOT_PASSWORD = 'FORGOT-PASS',
  SIGN_IN = 'SIGN_IN',
}

const padButton = {
  marginRight:'10px'
};

type SignInEmailProps = ISignInEmailOwnProps;

interface ISignInEmailState {
  alert: null | string;
  alertIntent?: Intent;
  currentUser: null | firebase.auth.UserCredential;
  currentView: SignInDialogView;
  email: string;
  emailInputError: null | string;
  emailTouched: boolean;
  emailValid: boolean;
  loadingCreateAccount: boolean;
  loadingForgotPassword: boolean;
  loadingSignIn: boolean;
  password: string;
  passwordInputError: null | string;
  passwordTouched: boolean;
  passwordValid: boolean;
  passwordConfirm: string;
  passwordConfirmInputError: null | string;
  passwordConfirmTouched: boolean;
  passwordConfirmValid: boolean;
  requestStaffAccess: boolean;
}

export type SignInEmailState = ISignInEmailState;

const AlertText = styled('p')`
  color: ${(props: { intent?: Intent }) =>
    props.intent === 'danger' ? Colors.RED1 : Colors.BLUE1};
  margin-bottom: 1rem;
  max-width: 18rem;
  text-align: center;
`;

class SignInEmail extends React.PureComponent<
  SignInEmailProps,
  SignInEmailState
> {
  public initialState: SignInEmailState = {
    alert: null,
    currentUser: null,
    currentView: SignInDialogView.SIGN_IN,
    email: '',
    emailInputError: null,
    emailTouched: false,
    emailValid: false,
    loadingCreateAccount: false,
    loadingForgotPassword: false,
    loadingSignIn: false,
    password: '',
    passwordConfirm: '',
    passwordConfirmInputError: null,
    passwordConfirmTouched: false,
    passwordConfirmValid: false,
    passwordInputError: null,
    passwordTouched: false,
    passwordValid: false,
    requestStaffAccess: false,
  };

  constructor(props: SignInEmailProps) {
    super(props);

    this.state = this.initialState;
  }

  public componentDidUpdate(prevProps: never, prevState: SignInEmailState) {
    const { onToggleDialogLock } = this.props;
    const {
      loadingCreateAccount: prevLoadingCreateAccount,
      loadingSignIn: prevLoadingSignIn,
    } = prevState;
    const { loadingCreateAccount, loadingSignIn } = this.state;

    if (prevLoadingCreateAccount === false && loadingCreateAccount === true) {
      onToggleDialogLock();
    }
    if (prevLoadingSignIn === false && loadingSignIn === true) {
      onToggleDialogLock();
    }
  }

  public render() {
    const {
      alert,
      alertIntent,
      // currentUser,
      currentView,
      email,
      emailInputError,
      emailTouched,
      emailValid,
      loadingCreateAccount,
      loadingForgotPassword,
      loadingSignIn,
      password,
      passwordConfirm,
      passwordConfirmInputError,
      passwordConfirmTouched,
      passwordConfirmValid,
      passwordInputError,
      passwordTouched,
      passwordValid,
      // requestStaffAccess,
    } = this.state;
    const formDisabled = loadingCreateAccount || loadingSignIn;
    const createAccountButtonDisabled =
      formDisabled || !(emailValid && passwordValid && passwordConfirmValid);
    const forgotPasswordButtonDisabled = formDisabled || !emailValid;
    const signInButtonDisabled = formDisabled || !(emailValid && passwordValid);
    const emailIntent = emailTouched
      ? emailValid
        ? emailInputError
          ? 'danger'
          : 'success'
        : 'danger'
      : undefined;
    const emailHelperText =
      emailIntent === 'danger'
        ? emailInputError || `your email should look like "name@example.com"`
        : '\u200b';
    const passwordConfirmIntent = passwordConfirmTouched
      ? passwordConfirmValid
        ? passwordConfirmInputError
          ? 'danger'
          : 'success'
        : 'danger'
      : undefined;
    const passwordConfirmHelperText =
      passwordConfirmIntent === 'danger'
        ? passwordConfirmInputError || 'the two passwords need to match'
        : '\u200b';
    const passwordIntent = passwordTouched
      ? passwordValid
        ? passwordInputError
          ? 'danger'
          : 'success'
        : 'danger'
      : undefined;
    const passwordHelperText =
      passwordIntent === 'danger'
        ? passwordInputError || 'your password needs to be 6+ characters'
        : '\u200b';
    const createAccountButtons = (
      <div>
       <div id="creatactbtn">
          <Button
            intent="primary"
            minimal={true}
            onClick={this.toSignIn}
            text="go back"
            style={padButton}
          />
          <Button
            disabled={createAccountButtonDisabled}
            intent="primary"
            loading={loadingCreateAccount}
            onClick={this.handleCreateAccount}
            text="create account"
            style={padButton}
          />
        </div>
      </div>
    );
    const forgotPasswordButtons = (
      <div>
        <div id="forgot-pass-btn">
          <Button
            intent="primary"
            minimal={true}
            onClick={this.toSignIn}
            text="go back"
            style={padButton}
          />
          <Button
            disabled={forgotPasswordButtonDisabled}
            intent="primary"
            loading={loadingForgotPassword}
            onClick={this.handleForgotPassword}
            text="send reset email"
            style={padButton}
          />
        </div>
      </div>
    );
    const signInButtons = (
      <div>
        <div id="signbtnid">
          <Button
            disabled={signInButtonDisabled}
            intent="primary"
            loading={loadingSignIn}
            onClick={this.signIn}
            text="sign in"
            style={padButton}
          />
          <Button
            intent="primary"
            minimal={true}
            onClick={this.toCreateAccount}
            text="create account"
            style={padButton}
          />
          <Button
            intent="primary"
            minimal={true}
            onClick={this.toForgotPassword}
            text="forgot password?"
            style={padButton}
          />
      </div>
      </div>
    );

    return (
      <DialogPanelContainer className={Classes.DIALOG_BODY}>
        {alert && <AlertText intent={alertIntent}>{alert}</AlertText>}
        <FormGroup
          disabled={formDisabled}
          helperText={emailHelperText}
          intent={emailIntent}
          label="Email"
          labelFor="email-input">
          <InputGroup
            id="email-input"
            intent={emailIntent}
            name="email"
            onBlur={this.touchEmail}
            onChange={this.handleInputChange}
            type="email"
            value={email}
          />
        </FormGroup>
        {(currentView === SignInDialogView.CREATE_ACCOUNT ||
          currentView === SignInDialogView.SIGN_IN) && (
          <FormGroup
            disabled={formDisabled}
            helperText={passwordHelperText}
            intent={passwordIntent}
            label="Password"
            labelFor="password-input">
            <InputGroup
              id="password-input"
              intent={passwordIntent}
              name="password"
              onBlur={this.touchPassword}
              onChange={this.handleInputChange}
              type="password"
              value={password}
            />
          </FormGroup>
        )}
        {currentView === SignInDialogView.CREATE_ACCOUNT && (
          <>
            <FormGroup
              disabled={formDisabled}
              helperText={passwordConfirmHelperText}
              intent={passwordConfirmIntent}
              label="Confirm Password"
              labelFor="password-confirm-input">
              <InputGroup
                id="password-confirm-input"
                intent={passwordConfirmIntent}
                name="passwordConfirm"
                onBlur={this.touchPasswordConfirm}
                onChange={this.handleInputChange}
                type="password"
                value={passwordConfirm}
              />
            </FormGroup>
            {/* <Checkbox
              checked={requestStaffAccess}
              onChange={this.handleRequestStaffAccess}
              label="Request staff access?"
              style={{ marginBottom: '2rem' }}
            /> */}
          </>
        )}
        {(() => {
          switch (currentView) {
            case SignInDialogView.CREATE_ACCOUNT:
              return createAccountButtons;
            case SignInDialogView.FORGOT_PASSWORD:
              return forgotPasswordButtons;
            case SignInDialogView.SIGN_IN:
              return signInButtons;
            default:
              return null;
          }
        })()}

        {/* {currentUser && (
          <StaffOnboarding
            currentUser={currentUser}
            defaultOpen={true}
            onComplete={this.staffAccessRequestComplete}
          />
        )} */}
      </DialogPanelContainer>
    );
  }

  // private staffAccessRequestComplete = () => {
  //   this.props.onToggleDialogLock(false);
  //   this.props.onCloseDialog();
  // };

  private handleCreateAccount = async () => {
    const { email, passwordConfirm, requestStaffAccess } = this.state;

    if (requestStaffAccess) {
      this.setState({ loadingCreateAccount: true });

      const result = await createAccountWithEmail(email, passwordConfirm);

      if (typeof result === 'string') {
        this.handleCreateAccountError(result);
      } else {
        this.setState({ currentUser: result });
      }
    } else {
      this.createAccountOnly();
    }
  };

  private createAccountOnly = async () => {
    const { onCloseDialog } = this.props;
    const { email, passwordConfirm } = this.state;

    this.setState({ loadingCreateAccount: true });

    const result = await createAccountWithEmail(email, passwordConfirm);

    this.setState({ loadingCreateAccount: false });

    if (typeof result === 'string') {
      this.handleCreateAccountError(result);
    } else {
      onCloseDialog();
    }
  };

  private handleCreateAccountError = (code: string) => {
    this.props.onToggleDialogLock(false);

    if (code === 'auth/email-already-in-use') {
      return this.setState({
        alert:
          'This email account is already in use. See if you can remember the password you used.',
        alertIntent: 'danger',
        currentView: SignInDialogView.SIGN_IN,
      });
    }

    if (code === 'auth/weak-password') {
      return this.setState({
        passwordConfirmInputError: `Your password isn't strong enough. Add some characters!`,
      });
    }

    const trySignInCodes = this.handleSignInError(code);

    if (trySignInCodes) {
      throw new Error(`create account threw an unexpected error-code: ${code}`);
    } else {
      return code;
    }
  };

  private handleEmail = (email: string) => {
    const emailValid = this.validateEmail(email);

    if (emailValid) {
      this.setState({ emailInputError: null, emailTouched: true, emailValid });
    } else {
      this.setState({ emailValid });
    }
  };

  private handleForgotPassword = async () => {
    try {
      const { email } = this.state;

      this.setState({ loadingForgotPassword: true });

      await auth.sendPasswordResetEmail(email);

      this.setState({
        alert:
          'A password reset link has been sent. Please check your email for further instructions.',
        alertIntent: 'success',
        email: '',
        loadingForgotPassword: false,
      });
    } catch (error) {
      this.setState({
        alert: error.message,
        alertIntent: 'danger',
        loadingForgotPassword: false,
      });
    }
  };

  private handlePassword = (password: string) => {
    const passwordValid = this.validatePassword(password);

    if (passwordValid) {
      this.setState({
        passwordInputError: null,
        passwordTouched: true,
        passwordValid,
      });
    } else {
      this.setState({ passwordValid });
    }
  };

  private handlePasswordConfirm = (passwordConfirm: string) => {
    const { password, passwordValid } = this.state;

    const passwordConfirmValid = passwordValid && passwordConfirm === password;

    if (passwordConfirmValid) {
      this.setState({
        passwordConfirmInputError: null,
        passwordConfirmTouched: true,
        passwordConfirmValid,
      });
    } else {
      this.setState({ passwordConfirmValid });
    }
  };

  private handleInputChange = (event: React.FormEvent<HTMLInputElement>) => {
    const {
      currentTarget: { name, value },
    } = event;

    if (name === 'email') {
      this.setState({ email: value });
      this.handleEmail(value);
    }

    if (name === 'password') {
      this.setState({ password: value });
      this.handlePassword(value);
    }

    if (name === 'passwordConfirm') {
      this.setState({ passwordConfirm: value });
      this.handlePasswordConfirm(value);
    }
  };

  private handleSignInError = (code: string) => {
    this.props.onToggleDialogLock(false);

    if (code === 'auth/user-not-found') {
      return this.setState({
        alert: `Looks like you don't have an account yet. Just confirm your password and we'll sign you right up!`,
        currentView: SignInDialogView.CREATE_ACCOUNT,
      });
    }

    if (code === 'auth/invalid-email') {
      return this.setState({
        alert: `Your email doesn't look valid. Please try again.`,
        alertIntent: 'danger',
      });
    }

    if (code === 'auth/user-disabled') {
      return this.setState({
        alert:
          'Sorry, your account has been disabled. Contact support to see if we can fix the situation.',
        alertIntent: 'danger',
      });
    }

    if (code === 'auth/wrong-password') {
      return this.setState({
        alert: `You can reset your password with the 'reset password' button below.`,
        alertIntent: 'danger',
        passwordInputError: 'Sorry, wrong password.',
      });
    }

    return code;
  };

  private signIn = async () => {
    const { onCloseDialog } = this.props;
    const { email, password } = this.state;

    this.setState({ loadingSignIn: true });

    const result = await signInWithEmail(email, password);

    this.setState({ loadingSignIn: false });

    if (typeof result === 'string') {
      this.handleSignInError(result);
    } else {
      onCloseDialog();
    }
  };

  private toCreateAccount = () =>
    this.setState({ currentView: SignInDialogView.CREATE_ACCOUNT });
  private toForgotPassword = () =>
    this.setState({ currentView: SignInDialogView.FORGOT_PASSWORD });
  private toSignIn = () =>
    this.setState({ currentView: SignInDialogView.SIGN_IN });

  private touchEmail = () => this.setState({ emailTouched: true });

  private touchPassword = () => this.setState({ passwordTouched: true });

  private touchPasswordConfirm = () =>
    this.setState({ passwordConfirmTouched: true });

  private validateEmail = (value: string) => {
    const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g;

    return emailRegex.test(value);
  };

  private validatePassword = (value: string) => {
    const passwordRegex = /\w{6}/g;

    return passwordRegex.test(value);
  };

  // private handleRequestStaffAccess = ({
  //   currentTarget: { checked },
  // }: React.FormEvent<HTMLInputElement>) => {
  //   this.setState({ requestStaffAccess: checked });
  // };
}

export default SignInEmail;



// WEBPACK FOOTER //
// ./src/components/SignIn/Email.tsx